import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import routes from '@/data/fullRoutesWithDefaultPath';
import Util from '@/util';

Vue.use(Router);

function authorized(available, requested) {
  if (requested && requested instanceof Array && requested.length > 0) {
    let isAuthorized = true;
    requested.forEach(p => {
      if (!available.includes(p)) {
        isAuthorized = false;
      }
    });

    return isAuthorized;
  }
  return true;
}

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: Util.loadPage('Login'),
      meta: {
        public: true,
      }
    },
    {
      path: '/logout',
      component: Util.loadPage('Logout'),
      meta: {
        public: true,
      }
    },
    {
      path: '/ssocb',
      component: Util.loadPage('Ssocb'),
      meta: {
        public: true,
      }
    },
    {
      path: '/403',
      component: Util.loadPage('Unauthorized'),
      meta: {
        public: true,
      }
    },
    {
      path: '/support',
      component: Util.loadPage('Layout'),
      props: { category: 'support' },
      children: routes.support,
      meta: {
        public: true,
      }
    },
    {
      path: '/sales',
      component: Util.loadPage('Layout'),
      props: { category: 'sales' },
      children: routes.sales,
      meta: {
        public: true,
      }
    },
    {
      path: '/',
      name: 'landing',
      component: Util.loadPage('Landing'),
      meta: {
        public: true,
      }
    },
    {
      path: '/*',
      component: Util.loadPage('NotFound'),
      meta: {
        public: true,
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    return next();
  }
  // In future, remove certain meta.public from routes and check access permission in store
  if (store.getters.loggedIn && store.state.user) {
    if (authorized(store.state.user.permissions, to.meta.requiresPermissions)) {
      return next();
    }
    return next('/403');
  }
  return next();
  // return next({
  //   path: '/login',
  //   query: { redirect: to.fullPath }
  // });
});

export default router;
